import { DoubleProjectElementSchema } from '../../schema/pageElements.val';
import ProjectElement from './ProjectElement';

interface DoubleProjectElementProps extends DoubleProjectElementSchema {
  priority?: boolean;
}

const DoubleProjectElement = ({
  leftProject,
  rightProject,
  reverseOrder = false,
  alignSquareToTop = false,
  priority = false,
}: DoubleProjectElementProps) => {
  const alignTopClass = alignSquareToTop ? 'items-start' : '';
  return (
    <div className="w-full">
      <div
        className={`flex flex-col tablet:flex-row justify-between gap-x-192 laptop:max-w-[1920px] ${alignTopClass}`}
      >
        <div className="w-full laptop:max-w-[808px] basis-1/2">
          <ProjectElement
            priority={priority}
            type={'projectElement'}
            image={leftProject.image}
            projectTitle={leftProject.projectTitle}
            clientName={leftProject.clientName}
            isRectangular={reverseOrder === true}
            url={leftProject.url}
            services={leftProject.services}
          />
        </div>
        <div className="w-full laptop:max-w-[808px] basis-1/2 mt-128 tablet:mt-0">
          {rightProject && (
            <ProjectElement
              priority={priority}
              type={'projectElement'}
              image={rightProject.image}
              projectTitle={rightProject.projectTitle}
              clientName={rightProject.clientName}
              isRectangular={!reverseOrder}
              url={rightProject.url}
              services={rightProject.services}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default DoubleProjectElement;
